// Module
var code = `<h2 class="section-header">Atm batch acquirers upload</h2>

<form name="\$ctrl.form" novalidate>
  <table class="table table--generate-row-ids">
    <tbody>
      <tr>
        <td></td>
        <td>ATM Network:</td>
        <td>
          <select name="atmNetwork"
                  class="form-control"
                  ng-model="\$ctrl.upload.network"
                  ng-options="atmNetwork.value as atmNetwork.label for atmNetwork in \$ctrl.atmNetworks"
                  ng-change="\$ctrl.clearSimulation()"
                  required>
          </select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>File type:</td>
        <td>
          <select name="fileType"
                  class="form-control"
                  ng-model="\$ctrl.upload.fileType"
                  ng-options="fileType.value as fileType.label for fileType in \$ctrl.fileTypes"
                  ng-change="\$ctrl.clearSimulation()"
                  required>
          </select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Remarks:</td>
        <td>
          <input
            type="text"
            ng-model="\$ctrl.upload.remarks"
            ng-change="\$ctrl.clearSimulation()"
          />
        </td>
      </tr>
      <tr>
        <td></td>
        <td>File:</td>
        <td>
          <file-id-upload
            single-file="true"
            ng-model="\$ctrl.upload.attachedFileId"
            validate="{pattern: '*.txt', size: { max: '5MB'}}"
            enable-webcam="false"
            max-files="1"
            show-remarks="false"
            ng-change="\$ctrl.clearSimulation()"
            required
          >
          </file-id-upload>
        </td>
      </tr>
    </tbody>
  </table>

  <div ng-if="\$ctrl.simulation">
    <h2 class="section-header">File summary</h2>

    <div ng-if="\$ctrl.simulation.perRowFormatErrors.length > 0">
      <validator condition="false"></validator>

      <div class="alert alert--danger file-error-alert" >
        File has format errors:
      </div>

      <dynamic-list
        columns="\$ctrl.formatErrorColumns"
        data="\$ctrl.simulation.perRowFormatErrors"
        list-type="'ERROR'"
      >
      </dynamic-list>
    </div>

    <div ng-if="\$ctrl.simulation.perRowBusinessErrors.length > 0">
      <validator condition="false"></validator>

      <div class="alert alert--danger file-error-alert" >
        File has payment errors:
      </div>

      <dynamic-list
        columns="\$ctrl.businessErrorColumns"
        data="\$ctrl.simulation.perRowBusinessErrors"
        list-type="'ERROR'"
        generate-row-ids="false"
      >
      </dynamic-list>
    </div>

    <div ng-if="\$ctrl.simulation.perRowSuccessfulPayments.length > 0">
      <div class="alert file-error-alert" >
        Valid rows:
      </div>

      <dynamic-list
        columns="\$ctrl.successfulColumns"
        data="\$ctrl.simulation.perRowSuccessfulPayments"
        generate-row-ids="false"
      >
      </dynamic-list>
    </div>
  </div>

  <div class="summary-actions">
    <button
        type="button"
        class="btn btn-warning"
        ng-click="\$ctrl.resetForm()">
      Clear form
    </button>
    <button
      ng-if="!\$ctrl.simulation"
      type="button"
      class="btn btn-success"
      ng-click="\$ctrl.simulatePayment()"
      ng-disabled="\$ctrl.form.\$invalid">
      Upload file
    </button>
    <button
        ng-if="\$ctrl.simulation"
        type="button"
        class="btn btn-success"
        ng-click="\$ctrl.submitPayment()"
        ng-disabled="\$ctrl.form.\$invalid">
      Submit payment
    </button>
  </div>
</form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/atm/batch/atm-batch-acquirers-upload.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;